import type { InternalAxiosRequestConfig } from 'axios';
import type { HttpError } from './error';

export interface ApiRequestInfo {
  url?: string;
  method?: string;
}

export interface ApiConfig {
  baseUrl: string;
  defaultHeaders?: Record<string, string>;
  /**
   * Envia os cookies do navegador junto das requisições. Padrão: `true`.
   * Apps nativos que injetam o cookie de sessão manualmente (via `onRequest`) usam `false`.
   */
  withCredentials?: boolean;
  onRequest?: (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig;
  /** Chamado com o erro já normalizado, antes de a requisição ser rejeitada (ex.: reportar ao Sentry). */
  onResponseError?: (error: HttpError, request: ApiRequestInfo) => void;
  /** Sobrescreve nome e mensagem do erro quando o servidor não responde (falha de rede, timeout). */
  networkError?: { name: string; message: string };
}

let config: ApiConfig | null = null;

export function configureApi(apiConfig: ApiConfig): void {
  config = apiConfig;
}

export function getConfig(): ApiConfig {
  if (!config) {
    throw new Error('@linka/api: configureApi() must be called before using any API hooks.');
  }

  return config;
}
